import MyService from '../../service';

const VehicleApi = {
  getVehicles: async () => {
    const result = await MyService.getRequestData('/vehicles');
    return result ? result.data : [];
  },
  creatCar: async (data) => {
    let result = null;
    result = await MyService.postRequestData('/vehicles', data);
    return result;
  },

  editCar: async (data) => {
    let result = null;
    result = await MyService.postRequestData('/vehicles/edit-car', data);
    return result;
  },
  getByOptions: async (option) => {
    let result = null;
    result = await MyService.getRequestData(
      '/vehicles/get-option-vehicle',
      option
    );
    return result ? result.data : result;
  },
  getDetailVehicle: async (vhcId) => {
    let result = null;
    result = await MyService.getRequestData('/vehicles/get-detail-vehicle', {
      vhc_id: vhcId,
    });
    return result ? result.data : result;
  },

  getVehicleByTypeId: async (typeId) => {
    const result = await MyService.getRequestData(`/vehicles/${typeId}`);
    return result ? result.data : [];
  },
};

export default VehicleApi;
